import {
    APP_NAME,
    APP_URL,
    API_URL,
    APP_DOMAIN,
    LOGO_PATH,
    ENABLE_STORE,
    ENABLE_MODULE_PARTNER,
    MIDTRANS_CLIENT_KEY,
    MIDTRANS_SCRIPT_URL,
    URL_SUPPORT_TEAM,
    API_SHORTENURL_URL
} from 'configuration';

const AppConsts = {
    APP_NAME: APP_NAME,
    Logos_APPURL: APP_URL,
    Logos_APIURL: API_URL,
    Logos_APP_DOMAIN: APP_DOMAIN,
    LOGO_PATH: LOGO_PATH,
    ENABLE_STORE: ENABLE_STORE,
    ENABLE_MODULE_PARTNER: ENABLE_MODULE_PARTNER,
    UrlSupportTeam: URL_SUPPORT_TEAM,
    API_SHORTENURL_URL: API_SHORTENURL_URL,
    Midtrans: {
        ClientKey: MIDTRANS_CLIENT_KEY,
        ScriptUrl: MIDTRANS_SCRIPT_URL
    }
};

export default AppConsts;